/**
 * Status chip cell for server-backed grids.
 *
 * The grid-column face of the shared StatusChip pill — use it in grid
 * renderCells, grid toolbar filter options, and the mobile card variants of
 * grid pages. Non-grid surfaces (detail pages, drawers, dashboards) import
 * StatusChip (@sophocles/components/StatusChip) directly instead.
 */
import React from 'react';

import StatusChip from '@sophocles/components/StatusChip';

/**
 * @param {object} props
 * @param {React.ReactNode} props.label - Short status text (already translated).
 * @param {'ok'|'warning'|'bad'|'info'|'attention'|'neutral'} [props.color]
 *   Status-palette family (see StatusChip / cssTokens.js).
 * @param {object} [props.sx] - Extra sx merged onto the pill.
 */
export default function GridStatusCell(props) {
  return <StatusChip {...props} />;
}
